import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { SharedDataService } from "../services/shared-data.service";
import { UserSubscriber } from "@app/shared/subscribers/user.subscriber";
import { UserService } from "../services/user.service";
import { IUser, User } from "../models/user";

@Injectable({
  providedIn: "root",
})
export class QuestionnaireAccessGuard implements CanActivate {
  constructor(
    private _userSubscriber: UserSubscriber,
    private _userService: UserService,
    private _route: Router,
    private _sharedDataService: SharedDataService
  ) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this._userService.getUser().subscribe({
        next: (result: IUser) => {
          const user = new User(result);
          this._userSubscriber.handleUserDepartment(user);

          if (!this._sharedDataService.userIsAdmin) {
            this._route.navigate(['main']);
            return resolve(false);
          }

          resolve(true);
        },
      });
    });
  }
}
